import React from 'react';
import { Link } from 'react-router-dom';
import { FaTimes, FaChevronRight } from 'react-icons/fa';
import '../../css/layout/MobileMenu.css';

const MobileMenu = ({ 
  navItems, 
  isOpen, 
  onClose, 
  mobileDropdownOpen, 
  onToggleDropdown,
  onSearchClick 
}) => {
  return (
    <div className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}>
      <button 
        className="mobile-close-button" 
        onClick={onClose} 
        aria-label="Close mobile menu"
      >
        <FaTimes />
      </button>
      
      <div className="mobile-menu-content">
        <ul className="mobile-nav-list">
          {navItems.map((item) => (
            <li key={item.path} className="mobile-nav-item">
              {item.dropdown ? (
                <div className="mobile-dropdown">
                  <button 
                    className="mobile-nav-link mobile-dropdown-toggle"
                    onClick={() => onToggleDropdown(item.path)}
                  >
                    {item.label}
                    <FaChevronRight className={`mobile-dropdown-arrow ${mobileDropdownOpen === item.path ? 'open' : ''}`} />
                  </button>
                  <ul className={`mobile-dropdown-menu ${mobileDropdownOpen === item.path ? 'open' : ''}`}>
                    {item.dropdown.map((dropdownItem) => (
                      <li key={dropdownItem.path}>
                        {dropdownItem.external ? (
                          <a 
                            href={dropdownItem.path} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="mobile-dropdown-link" 
                            onClick={onClose}
                          >
                            {dropdownItem.label}
                          </a>
                        ) : (
                          <Link 
                            to={dropdownItem.path} 
                            className="mobile-dropdown-link" 
                            onClick={onClose}
                          >
                            {dropdownItem.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : item.external ? (
                <a 
                  href={item.path} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="mobile-nav-link" 
                  onClick={onClose}
                >
                  {item.label}
                </a>
              ) : (
                <Link 
                  to={item.path} 
                  className="mobile-nav-link" 
                  onClick={onClose}
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
          <li>
            <button
              className="mobile-search-button"
              aria-label="Search"
              onClick={() => {
                onSearchClick();
                onClose();
              }}
            >
              Search
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;

